<template>
    <div class="about-shell">
        <div class="sider-shell">
            <div class="sider-box" v-for="(item,index) in sider_list" :key="index"
                 :class="{'sider-box-active': item.code==sider_code}" @click="cut_nav(item,index)">
                {{item.name}}
            </div>
        </div>
        <div class="content-shell">
            <div class="content-title">
                长沙市湘源医药食品职业培训学校
            </div>
            <div class="content-box" v-show="sider_code==1">
                  <pre class="linkman">
地址：长沙市芙蓉区湖南生物机电学院东湖校区培训楼A栋
客服电话：400-811-5865转1
电话：0731-82229030 17773138860（微信号同号）
联系人： 龙老师 周老师
湖南省医药食品教育培训平台：http://www.xyyysp.com
南开大学现代远程教育网站：http://istudy.nankai.edu.cn
        </pre>
                <img src="http://www.xyyysp.com/static/image/map.png" alt="" class="address-img">
                <pre class="other-address">
长沙市湘源医药食品职业培训学校
南开大学现代远程教育长沙学习中心
湖南省食品药品监管系统人才培训基地
湖南省食品安全教育面授培训机构
长沙市食品安全教育面授培训机构
          </pre>
            </div>
            <div class="content-box" v-show="sider_code==2">
 <pre class="intro-content">
     湖南省医药食品教育培训平台始建于2015年，是长沙市湘源医药食品职业培训学校的行业门户网站之一。网站立足于湖南
省医药食品行业，为本地用户群提供医药食品及相关的信息服务，提供专业的医药食品考试资讯，是湖南本土最权威的医药网络媒体。
   长沙市湘源医药食品职业培训学校是长沙市人力资源和社会保障局批准的正规合法办学机构。（办学许可证：人社民18010
14000109号）。湖南省食品药品监督管理局监管干部培训基地、南开大学现代远程教育学院长沙湘源学习中心、湖南省执业药
师协会执业药师考前辅导培训优秀合作单位、医学教育网湖南地区总经销商，同时也是医学教育网2016年湖南长沙执业药师面授
视频直播录播班承办单位。学校座落于长沙市芙蓉区隆平高科技园湖南生物机电学院东湖校区内，地理位置优越，交通便捷。
    "因为专注，所以专业"，学校秉承"用心服务，教学高质"的办学理念，长期致力于医药、食品安全管理员方面的专业培训，
开设有医药商品购销员、中药购销员、营养师、执业药师考前辅导、GSP认证、药店店长等医药食品类教育培训。学校常年特聘
 中南大学、湖南师范大学、湖南农业大学、湖南中医药大学、南华大学等高校知名专家教授、医药界资深专家、政府官员和著名
企业高管等授课，另与多家国内专业培训机构建立了战略合作伙伴关系。以就业为导向，以服务为宗旨，坚持"规范办学、严格管
 理、科学培训、争创一流"的办学方针，本着"对学员负责，对企业负责，对社会负责"的精神，以人为本，脚踏实地，不断创新，
更好地为社会服务。
    "因为专注，所以专业"，学校秉承"用心服务，教学高质"的办学理念，长期致力于医药、食品安全管理员方面的专业培训，
开设有医药商品购销员、中药购销员、营养师、执业药师考前辅导、GSP认证、药店店长等医药食品类教育培训。学校常年特聘
中南大学、湖南师范大学、湖南农业大学、湖南中医药大学、南华大学等高校知名专家教授、医药界资深专家、政府官员和著名
企业高管等授课，另与多家国内专业培训机构建立了战略合作伙伴关系。以就业为导向，以服务为宗旨，坚持"规范办学、严格管
理、科学培训、争创一流"的办学方针，本着"对学员负责，对企业负责，对社会负责"的精神，以人为本，脚踏实地，不断创新，
更好地为社会服务。
    长沙市湘源医药食品职业培训学校是长沙市人力资源和社会保障局批准的正规合法办学机构。（办学许可证：人社民18010
14000109号）。湖南省食品药品监督管理局监管干部培训基地、南开大学现代远程教育学院长沙湘源学习中心、湖南省执业药
师协会执业药师考前辅导培训优秀合作单位、医学教育网湖南地区总经销商，同时也是医学教育网2016年湖南长沙执业药师面授
视频直播录播班承办单位。学校座落于长沙市芙蓉区隆平高科技园湖南生物机电学院东湖校区内，地理位置优越，交通便捷。
</pre>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'AboutUs',
    data () {
      return {
        tabPosition: 'left',
        sider_code: 1,
        sider_list: [
          {
            name: '联系我们',
            code: 1
          },
          {
            name: '学校简介',
            code: 2
          }
        ]
      }
    },
    methods: {
      cut_nav (item, index) {
        this.sider_code = item.code
      }
    }
  }
</script>

<style lang="less" scoped>
    .about-shell {
        display: flex;
        width: 1200px;
        margin: 30px auto;

        .sider-shell {
            min-width: 200px;
            margin-right: 20px;

            .sider-box {
                display: flex;
                align-items: center;
                height: 90px;
                padding: 20px;
                position: relative;
                font-size: 20px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                background-color: #fff;
            }

            .sider-box-active {
                font-size: 20px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #2AA9B5;

                &:after {
                    position: absolute;
                    left: 0px;
                    top: 50%;
                    transform: translateY(-50%);
                    content: '';
                    width: 4px;
                    height: 40px;
                    background-color: #2aa9b5;
                }
            }
        }
    }

    .address-img {
        height: 358px;
        width: 870px;
    }

    .content-shell {
        width: 100%;
        background-color: #fff;
    }

    .content-title {
        display: flex;
        align-items: center;
        height: 80px;
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        border-bottom: 1px solid #DBDBDB;
        margin-bottom: 10px;
        padding-left: 20px;
    }

    .intro-content {
        width: 960px;
        padding: 10px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #656565;
        line-height: 40px;
    }

    .linkman, .other-address {
        padding: 20px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 42px;
    }
</style>
